import React from "react";

import { PropsTypeSvg } from "@typings/global.types";

function CoinGreySvg({ classNameProps, width, height }: PropsTypeSvg) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNameProps}
      width={width}
      height={height}
      viewBox='0 0 30 30'
      fill='none'
    >
      <circle cx='15' cy='15' r='13.5' fill='#DBE2E6' />
      <g filter='url(#filter0_i_927_1772)'>
        <circle cx='15' cy='15' r='10.125' fill='#DBE2E6' />
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.7986 12.6564C18.697 13.3265 18.0918 14.0662 16.9331 14.0662H12.7408L13.164 11.2686H17.354C18.5127 11.2686 18.8984 11.9874 18.7986 12.6564ZM12.3906 16.3878H15.843L17.506 20.4057C17.6671 20.813 18.023 21.0747 18.6636 21.0747C19.4758 21.0747 20.134 20.4774 20.2422 19.7591C20.2775 19.5199 20.24 19.2812 20.144 19.0906L18.8644 15.9815C20.5848 15.3591 21.4837 14.1377 21.7033 12.6782C22.0172 10.601 20.7906 8.92468 17.2654 8.92468H12.0386C11.2242 8.92468 10.4611 9.56962 10.343 10.3591L8.941 19.6408C8.82293 20.4287 9.39124 21.0747 10.2051 21.0747C11.0195 21.0747 11.7837 20.4287 11.9018 19.6408L12.3906 16.3878Z'
        fill='#DBE2E6'
      />
      <defs>
        <filter
          id='filter0_i_927_1772'
          x='4.875'
          y='4.875'
          width='20.25'
          height='20.25'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='BackgroundImageFix'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='7.5' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect1_innerShadow_927_1772'
          />
        </filter>
      </defs>
    </svg>
  );
}

export default CoinGreySvg;
